export function B2CPostQuoteCompactStyles() {
  return (
    <style>
      {`
        .b2c-post-quote-compact .space-y-6 > * + * {
          margin-top: 0.75rem !important;
        }

        .b2c-post-quote-compact .grid.gap-4.md\\:grid-cols-2 {
          gap: 0.5rem !important;
        }

        .b2c-post-quote-compact label.border-dashed {
          min-height: 108px !important;
          padding: 0.75rem !important;
          border-radius: 0.75rem !important;
        }

        .b2c-post-quote-compact label.border-dashed p {
          line-height: 1.2;
        }

        .b2c-post-quote-compact .rounded-xl.border.px-3.py-2 {
          padding: 0.4rem 0.6rem !important;
        }

        .b2c-post-quote-compact .rounded-xl.border.px-3.py-2 .font-medium.text-\[12px\] {
          font-size: 11px !important;
          line-height: 1.2;
        }
      `}
    </style>
  );
}
